import * as yup from 'yup';

const converterStringParaNumero = (value, valorOriginal) => {
  if (!valorOriginal && valorOriginal !== 0) {
    return undefined;
  }

  if (typeof valorOriginal === 'string') {
    const valorConvertido = valorOriginal.replace(',', '.');
    const numero = parseFloat(valorConvertido);

    if (!Number.isNaN(numero)) {
      return numero;
    }
  }

  return valorOriginal;
};

export default yup.object().shape({
  categoria:
    yup.string().required('Categoria é requerida'),
  cnpj:
    yup.string().required('CNPJ é requerido'),
  referenciaTrust:
    yup.string(),
  classificacao:
    yup.string().required('Classificação é requerida'),
  filiais:
    yup.string().required('Filial é requerida'),
  aplicacao:
    yup.string().required('Aplicação é requerida'),
  incoterm:
    yup.string().required('Incoterm é requerido'),
  freteContainer:
    yup
      .string()
      .nullable()
      .required('Frete do Container é requerido')
      .matches(/^-?\d+(\.\d+)?$/, 'Frete Container com formato inválido'),
  qtdContainers:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Quantidade de Containers é requerida')
      .typeError('Quantidade de Containers com formato Inválido'),
  enderecoOrigem: yup.string().when('incoterm', {
    is: (value) => value === 'EXW' || value === 'FCA',
    then: yup.string().required('Endereço de Origem é requerido'),
  }),
  portoOrigem:
    yup.string().required('Porto de Origem é requerido'),
  portoDestino:
    yup.string().required('Porto de Destino é requerido'),
  logisticaNacional:
    yup.boolean().required('Logística nacional é requerida'),
  enderecoEntrega:
    yup.string().required('Endereço de entrega é requerido'),
  observacoes:
    yup.string(),
  solicitadoPor:
    yup.string().required(),
  status:
    yup.string().required(),
  produtos:
    yup.array(yup.object().shape({
      ncm:
        yup.string()
          .required('NCM é obrigatório.')
          .min(3, 'NCM deve ter no mínimo três caracteres.')
          .max(255),
      unidadeMedida:
        yup.string()
          .required('Unidade de medida é obrigatória.')
          .min(1, 'Unidade de medida deve ter no mínimo um caracter.')
          .max(255, 'Unidade de medida deve ter no máximo 255 caracteres.'),
      quantidade:
        yup.number()
          .nullable()
          .transform(converterStringParaNumero)
          .required('Peso líquido é requerido')
          .typeError('Formato do peso líquido inválido')
          .moreThan(0, 'Quantidade deve ser maior que 0'),
      valorUnitario:
        yup.number()
          .nullable()
          .transform(converterStringParaNumero)
          .required('Peso líquido é requerido')
          .typeError('Formato do peso líquido inválido')
          .moreThan(0, 'Valor Unitário deve ser maior que 0'),
      pesoLiquido:
        yup.number()
          .nullable()
          .transform(converterStringParaNumero)
          .required('Peso líquido é requerido')
          .typeError('Formato do peso líquido inválido')
          .moreThan(0, 'Valor Unitário deve ser maior que 0'),
      moeda:
        yup.string().required('Moeda é obrigatória.'),
      li:
        yup.string().required('LI é requerida'),
      ii: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('II é requerido')
        .typeError('Formato do II inválido'),
      ipi: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('IPI é requerido')
        .typeError('Formato do IPI inválido'),
      pis: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('PIS é requerido')
        .typeError('Formato do PIS inválido'),
      cofins: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('COFINS é requerido')
        .typeError('Formato do COFINS inválido'),
      cofinsCusto: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('COFINS Custo é requerido')
        .typeError('Formato do COFINS Custo inválido'),
      icms: yup
        .string()
        .nullable()
        .required('ICMS é obrigatório'),
      pisSaida: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .typeError('Formato do PIS de Saida inválido'),
      cofinsSaida: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .typeError('Formato do COFINS de Saida inválido'),
      markup: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Markup é requerido')
        .typeError('Formato do Markup inválido'),
      desconto: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Desconto é requerido')
        .typeError('Formato do desconto inválido'),
    })).required('Campo Requerido').min(1, 'A simulação deve ter ao menos um produto'),
  despesasAdministrativas:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Despesas Administrativas é requerida')
      .typeError('Formato das Despesas Administrativas inválido'),
  custoFinanceiro:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Custo Financeiro é requerido')
      .typeError('Formato do Custo Financeiro inválido'),
  despesaAgenteCarga:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Despesas de Agente de Carga é requerida')
      .typeError('Formato das Despesas de Agente de Carga inválido'),
  honorarioDespacho:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Honorário de Despacho é requerido')
      .typeError('Formato dos Honorários de Despacho inválido'),
  capatazia:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Capatazia é requerida')
      .typeError('Formato da Capatazia inválido'),
  seguroInternacional:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Seguro Internacional é requerido')
      .typeError('Formato do Seguro Internacional inválido'),
  freteDestino:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Frete de Destino é requerido')
      .typeError('Formato do Frete de Destino inválido'),
  acrescimos:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Acréscimos é Requerido')
      .typeError('Formato dos acréscimos inválido'),
  transbordo:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Transbordo é requerido')
      .typeError('Formato do Transbordo inválido'),
  taxaMoeda:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Taxa da Moeda é requerida')
      .typeError('Formato da Taxa da Moeda inválido'),
  adicionalIMO:
    yup
      .boolean()
      .nullable()
      .required('Carga Perigosa é requerida'),
  anuenciaEmissaoLI:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Taxa de Emissão de LI é requerida')
      .typeError('Formato da Taxa de Emissão de L.I inválido'),
  coletaPorto:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Coleta do Porto é requerida')
      .typeError('Formato da Coleta do Porto inválido'),
  custosOrigem:
    yup.number().when('incoterm', {
      is: 'EXW',
      then: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Custos de Origem é requerido')
        .typeError('Formato dos Custos de Origem inválido'),
    }),
  icmsST:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('ICMS ST é requerido')
      .typeError('Formato do ICMS ST inválido'),
  outrosCampos:
    yup.array(
      yup.object().shape({
        value:
          yup
            .number()
            .transform(converterStringParaNumero)
            .typeError('Formato do campo customizado inválido'),
      }),
    ),
});
